import React, { FC, useEffect, useState } from "react";
import { Descriptions } from "antd";
import moment from "moment";
import "./stakeInfo.scss";
import { convertFromWeiFormatted, userAPY } from "../../utils/number";
import { IStakeingData, IUser } from "../../types/Staking";

export const StakeInfoTable: FC<IStakeingData & IUser> = ({
  wallet,
  amountStaked,
  amountStakedwithBonus,
  lastStake,
  accountReward,
  kycStatus,
  telegramId,
  twitterId,
  telegramUsername,
  twitterUsername,
}) => {
  const [apy, setApy] = useState("");
  let a;
  const loadApy = async () => {
    a = await userAPY(
      Number(convertFromWeiFormatted(accountReward, 18, 5)),
      Number(lastStake),
      Number(convertFromWeiFormatted(amountStaked))
    );
    setApy(a);
  };

  useEffect(() => {
    loadApy();
  }, [accountReward]);

  return (
    <>
      <div className="table-size">
        <Descriptions
          column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 2 }}
          bordered
        >
          <Descriptions.Item label="User Wallet">{wallet}</Descriptions.Item>
          <Descriptions.Item label="Amount Staked">
            {convertFromWeiFormatted(amountStaked)}
          </Descriptions.Item>
          <Descriptions.Item label="Last Stake">
            {moment({}).seconds(lastStake).format("HH:mm:ss")}
          </Descriptions.Item>
          <Descriptions.Item label="Total Amount Staked with Bonus">
            {convertFromWeiFormatted(amountStakedwithBonus)}
          </Descriptions.Item>
          <Descriptions.Item label="Amount Reward">
            {convertFromWeiFormatted(accountReward)}
          </Descriptions.Item>
          <Descriptions.Item label="User APY">
            {apy ? `${apy}%` : "User not staked"}
          </Descriptions.Item>
          <Descriptions.Item label="Kyc Status">
            {kycStatus ? `${kycStatus}` : "User not in kyc"}
          </Descriptions.Item>
          <Descriptions.Item label="Telegram">
            {telegramId ? telegramUsername || "Connected" : "Not Connected"}
          </Descriptions.Item>
          <Descriptions.Item label="Twitter">
            {twitterId ? twitterUsername || "Connected" : "Not Connected"}
          </Descriptions.Item>
          <Descriptions.Item>{}</Descriptions.Item>
        </Descriptions>
      </div>
    </>
  );
};
